import React,{Component} from 'react'
import Card from './Card'


export default class Friends extends Component{
   constructor(props){
       super(props)
       this.state = {
        products: [
            { friendName:'Mehdi',title : 'Limelight', image: "http://cdn.shopify.com/s/files/1/2635/3244/products/DSC_2484_-_Copy.JPG?v=1553906693" , price: "1290",saveCount: 82},
            { friendName:'Hafiz Waleed',title : 'Limelight', image: "http://cdn.shopify.com/s/files/1/2635/3244/products/U0707-SSH-BLU_1.jpg?v=1552043754", price: "1290",saveCount: 82},
            { friendName:'Asjad',title : 'Limelight', image: "https://d224nth7ac0evy.cloudfront.net/catalog/product/cache/926507dc7f93631a094422215b778fe0/i/p/ipw-18-62-_3_.jpg", price: "1290",saveCount: 82},
            { friendName:'Abdullah',title : 'Limelight', image: "https://www.junaidjamshed.com/media/catalog/product/cache/image/e9c3970ab036de70892d86c6d221abfe/j/j/jjpw-a-jps-203-1.jpg", price: "1290",saveCount: 82},
            {friendName:'Basit',title : 'Limelight', image: "http://cdn.shopify.com/s/files/1/2635/3244/products/U0387-SSH-PNK_1.jpg?v=1551876015", price: "1290",saveCount: 82},
        ],
       }
   }
  render(){return(
         <div className="friendsParent">
         <ol className="friends-items">

         <li className="friend-item">
             <p>In the future you will see your friends and family saved collection here.For now happy finding dresses.Thanks</p>
         </li>
         {/* {this.state.products.map(item=>{
             return(
                 
                 <Card brandName={item.title} price={item.price} title={item.friendName} image={item.image} saveCount={item.saveCount}/>
                
         )})} */}
          </ol>
         </div>

  )}


}